import { Fab, Tooltip } from "@mui/material";
import React from "react";

// We can use this CustomFabButton component anywhere with giving its props.
export default function CustomFabButton(props) {
    return (
        <Tooltip title={props.title}>
            <Fab
                id={props.id ?? props.title}
                disabled={props.disabled}
                onClick={props.onClick}
                color={props.color ?? "primary"} // default color: primary
                aria-label={props.ariaLabel ?? "add"} // default label: add
                size={props.size ?? "small"} // default size: small
                style={props.style}
            >
                {props.icon}
            </Fab>
        </Tooltip>
    );
}
